import { Card, CardContent, CardHeader, CardTitle } from "../../../../../components/ui/card";
import { EntregoOpsItem } from "../types";

interface EntregoOpsTableProps {
  opsList: EntregoOpsItem[];
  selectedOps: string[];
  onSelectionChange: (selectedOps: string[]) => void;
}

export function EntregoOpsTable({
  opsList,
  selectedOps,
  onSelectionChange,
}: EntregoOpsTableProps) {
  const handleToggleOp = (ops: string) => {
    if (selectedOps.includes(ops)) {
      onSelectionChange(selectedOps.filter((o) => o !== ops));
    } else {
      onSelectionChange([...selectedOps, ops]);
    }
  };

  const handleToggleAll = () => {
    if (selectedOps.length === opsList.length) {
      onSelectionChange([]);
    } else {
      onSelectionChange(opsList.map((op) => op.ops));
    }
  };

  if (!Array.isArray(opsList) || opsList.length === 0) {
    return null;
  }

  const allSelected = selectedOps.length === opsList.length;

  return (
    <Card>
      <CardHeader>
        <CardTitle>Selecione os Franqueados</CardTitle>
      </CardHeader>
      <CardContent>
        <div className="space-y-2">
          <div className="flex items-center space-x-3 p-3 rounded-lg border bg-muted/50">
            <input
              type="checkbox"
              id="select-all"
              checked={allSelected}
              onChange={handleToggleAll}
              className="h-4 w-4 rounded border-gray-300 text-primary focus:ring-primary cursor-pointer"
            />
            <label
              htmlFor="select-all"
              className="text-sm font-medium cursor-pointer flex-1"
            >
              Selecionar Todos ({opsList.length})
            </label>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-2">
            {opsList.map((op) => (
              <div
                key={op.id}
                className="flex items-center space-x-3 p-3 rounded-lg border hover:bg-accent/50 transition-colors"
              >
                <input
                  type="checkbox"
                  id={op.id}
                  checked={selectedOps.includes(op.ops)}
                  onChange={() => handleToggleOp(op.ops)}
                  className="h-4 w-4 rounded border-gray-300 text-primary focus:ring-primary cursor-pointer"
                />
                <label
                  htmlFor={op.id}
                  className="text-sm font-medium cursor-pointer flex-1"
                >
                  {op.ops}
                </label>
              </div>
            ))}
          </div>
        </div>
      </CardContent>
    </Card>
  );
}
